const FeedbackData = [{
    id: 1,
    rating: 7,
    text: 'This is feedback item 1',
  },
  {
    id: 2,
    rating: 9,
    text: 'This is feedback item 2',
  },
  {
    id: 3,
    rating: 8,
    text: 'This is feedback item 3',
  },
]

export default FeedbackData